<template>
  <el-menu class="el-menu-vertical-admin" default-active="2" active-text-color="#3e10d5">
    <el-menu-item index='1004' @click="togglePhdRegistration">
      <template slot="title">
        <i class="el-icon-upload"></i>
        <span>Καταχώριση Διδακτορικών στο ΕΑΔΔ</span>
      </template>
    </el-menu-item>
    <el-menu-item index='1000' @click="toggleSearch">
      <template slot="title">
        <i class="el-icon-search"></i>
        <span>Αναζήτηση Αιτήσεων</span>
      </template>
    </el-menu-item>
  </el-menu>
</template>

<script>
export default {
  methods: {
    togglePhdRegistration () {
      this.$store.dispatch('SHOW_HIDE_PHD_REGISTRATION')
    },
    toggleSearch () {
      this.$store.dispatch('SHOW_HIDE_APPSEARCH')
    }
  }
}
</script>

<style lang='scss' scoped>
.is-active {
  color: blue;
}

.el-submenu {
  border-radius: 20px;
  overflow-wrap: break-word;
  border: 2px solid #7fa3bb;
  padding: 5px;
  &__title:hover {
    background-color: "#b3c0d1";
  }
}

.el-menu-vertical-admin {
  margin: 5px;
  word-wrap: break-word;
  border-radius: 0px 20px;
  border: 2px solid #7fa3bb;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/roleSpecific/PhdRegistryMenu.vue